import {Input} from "reactstrap";
import React from "react";
import {I18n} from "../../../I18n";

const LoanOrderStatusSelect = props => {
    const allOption = !props.required
        ? <option value="">{I18n[props.lang].ALL}</option>
        : null;
    const options = props.statuses
        ? props.statuses.map((value, i) =>
            <option value={value.status} key={i}>{value.message}</option>)
        : null;
    return (
        <Input
            className={props.className ? props.className : "mr-2"}
            type="select"
            name="status"
            id="status"
            onChange={props.onChange}
            value={props.status}
        >
            <option value="">{props.defaultOptionText}</option>
            {allOption}
            {options}
        </Input>
    )
}

export default LoanOrderStatusSelect


// WEBPACK FOOTER //
// ./src/components/Loan/Order/LoanOrderStatusSelect.js